<template>
	<div class="crop">
		<clipper-basic
			ref="clipper"
			:src="item.regular ? item.regular : item.url"
			:ratio="cleanCropRatio"
			:wrap-ratio="imageRatio"
			:style="{ 'max-width': `${maxWidth}%`}"
			@load="addElementsToClipper"
		/>
	</div>
</template>

<script>
import _debounce from 'lodash/debounce';

export default {
	props: {
		item: {
			type: Object,
			required: true,
		},

		ratio: {
			type: String,
			required: false,
			default: null,
		},

		minimumWidth: {
			type: Number,
			required: true,
		},

		minimumHeight: {
			type: Number,
			required: true,
		},
	},

	data() {
		return {
			imageWidth: null,
			imageHeight: null,
			minimumWidthPercentage: 0,
			minimumHeightPercentage: 0,
		};
	},

	computed: {
		cleanCropRatio() {
			if (this.ratio && this.ratio.split(':').length === 2) {
				const values = this.ratio.split(':');

				return values[0] / values[1];
			}

			return null;
		},

		ratioWidth() {
			if (this.ratio && this.ratio.split(':').length === 2) {
				return this.ratio.split(':')[0];
			}
			return null;
		},

		ratioHeight() {
			if (this.ratio && this.ratio.split(':').length === 2) {
				return this.ratio.split(':')[1];
			}
			return null;
		},

		imageRatio() {
			return this.imageWidth / this.imageHeight;
		},

		maxWidth() {
			if (window.innerWidth > 900) {
				return 26 * this.imageRatio;
			}

			if (window.innerWidth > 640) {
				return 70;
			}

			return 85;
		},
	},

	mounted() {
		const zoomArea = document.getElementsByClassName('zoom-area shadow')[0];
		zoomArea.style.color = 'rgba(46, 162, 248, 0.4)';
	},

	methods: {
		addElementsToClipper() {
			const clipper = document.getElementsByClassName('clipper-basic')[0];
			const grid = clipper.getElementsByClassName('grid')[0];

			this.$nextTick(() => {
				this.$refs.clipper.setTL$.next({ left: 0, top: 0 });
				this.minimumWidthPercentage = Math.ceil((this.minimumWidth * 100) / this.imageWidth);
				this.minimumHeightPercentage = Math.ceil((this.minimumHeight * 100) / this.imageHeight);

				if (this.cleanCropRatio) {
					let Xp = null;
					let Yp = null;

					if (this.imageHeight / this.ratioHeight < this.imageWidth / this.ratioWidth) {
						// Y is smaller than X
						const YY = this.imageHeight * 0.9;
						const XX = (this.ratioWidth / this.ratioHeight) * YY;
						Xp = (XX / this.imageWidth) * 100;
						Yp = 90;
					}

					if (this.imageWidth / this.ratioWidth < this.imageHeight / this.ratioHeight) {
						// X is smaller than Y
						const XX = this.imageWidth * 0.9;
						const YY = (this.ratioHeight / this.ratioWidth) * XX;

						Yp = (YY / this.imageHeight) * 100;
						Xp = 90;
					}

					this.$refs.clipper.setWH$.next({ width: Xp, height: Yp });
				} else {
					this.$refs.clipper.setWH$.next({ width: 90, height: 90 });
				}
			});

			grid.innerHTML = '';
			for (let i = 0; i < 16; i += 1) {
				const node = document.createElement('div');
				node.classList.add('custom-grid-item');
				grid.appendChild(node);
			}
			const cornerContainer = clipper.getElementsByClassName('corner')[0].parentElement;
			for (let i = 0; i < 4; i += 1) {
				const node = document.createElement('div');
				node.classList.add('grip');
				cornerContainer.appendChild(node);
			}

			this.$refs.clipper.onChange$.subscribe(() => {
				this.debouncedEmitChanged(this.$refs.clipper);
			});

			this.imageWidth = this.$refs.clipper.imgEl.naturalWidth;
			this.imageHeight = this.$refs.clipper.imgEl.naturalHeight;

			this.debouncedEmitChanged(this.$refs.clipper);
		},

		/* eslint-disable-next-line */
		debouncedEmitChanged: _debounce(function (clipper) {
			const specifications = {
				position: clipper.zoomTL$,
				height: clipper.zoomWH$.height,
				width: clipper.zoomWH$.width,
			};
			this.$emit('changed', specifications);
		}, 150),
	},
};
</script>

<style lang="scss" src="./crop.scss" />
